const removeFromLocalStorage = (key: 'readFacts' | 'viewedVideos' | 'returningUser' | 'completedFeedbackForm') => {
  if (typeof window === 'undefined') return
  localStorage.removeItem(key)
}

export default removeFromLocalStorage
